import React, { useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReceiptIcon from "@mui/icons-material/Receipt";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import RepeatIcon from "@mui/icons-material/Repeat";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

import MobileNav from "./MobileNav";
import { lipana_signup, lipana_login } from "../../Config/redirect_url";

const Nav = ({ logo }) => {
  const [active, setActive] = useState(false);
  const [showProducts, setShowProducts] = useState(false);

  const setNavBar = () => {
    setActive(!active);
  };

  const hideNavBar = () => {
    setActive(!active);
  };

  if (active) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "visible";
  }

  const navData = [
    { name: "Products", type: "text" },
    { name: "Pricing", type: "text" },
    { name: "Developers", type: "text" },
    { name: "Company", type: "text" },
    { name: "Contact", type: "text" },
  ];

  const accounts = [
    { name: "Sign In", type: "text" },
    { name: "Create free account", type: "btn" },
  ];

  const products = [
    {
      name: "Receive payments",
      items: [
        {
          name: "Invoices",
          icon: ReceiptIcon,
          text: "Send professional invoices to customers",
        },
        {
          name: "Payment links",
          icon: InsertLinkIcon,
          text: "Collect payments, subscriptions and  donations",
        },
        {
          name: "Recurring payments",
          icon: RepeatIcon,
          text: "Set up recurring payments easily",
        },
        {
          name: "QR code payments",
          icon: QrCode2Icon,
          text: "Go completely cashless in your business",
        },
      ],
    },
    {
      name: "Send payments",
      items: [
        {
          name: "Pay suppliers",
          icon: ArrowOutwardIcon,
          text: "Pay suppliers and contractors easily",
        },
      ],
    },
  ];

  return (
    <nav className="relative z-50 py-6 xl:px-0">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-row justify-between items-center w-full">
          <Link to="/" className="flex ml-5 flex-row items-center z-50 lg:ml-0">
            <img src={logo} alt="logos" className="h-8 w-full object-contain" />
          </Link>

          <div className="hidden relative z-50 flex-col space-y-8 lg:flex lg:space-y-0 lg:w-max lg:flex-row lg:space-x-5">
            {navData.map((link, i) => (
              <Link
                onMouseEnter={() =>
                  link.name.toLowerCase() === "products"
                    ? setShowProducts(true)
                    : ""
                }
                onMouseLeave={() =>
                  link.name.toLowerCase() === "products"
                    ? setShowProducts(false)
                    : ""
                }
                onClick={() => hideNavBar()}
                to={link.name === "Home" ? `/` : `/${link.name.toLowerCase()}`}
                key={i}
                className={`font-semibold${
                  link.type === "btn" ? `py-1 px-5 rounded-full` : ""
                } hover:text-[#FF9B00] duration-500 cursor-pointer`}
              >
                {link.name}{" "}
                {link.name.toLowerCase() === "products" ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  ""
                )}
              </Link>
            ))}

            {/* Products menu */}
            <div
              onMouseEnter={() => setShowProducts(true)}
              onMouseLeave={() => setShowProducts(false)}
              className={` ${
                showProducts ? `block` : `hidden`
              } bg-[#f8f7f4] rounded-xl p-8 text-blackColor top-10 -left-24 w-max absolute space-y-8`}
            >
              <Link to="https://app.lipana.co.ke/signup">
                <h2 className="font-semibold text-2xl">
                  Explore Lipana for business
                </h2>
                <p>Accept international payments and pay your suppliers</p>
              </Link>
              <div className="grid grid-cols-2 gap-x-10">
                {products.map((product, i) => (
                  <div key={i} className="space-y-5">
                    <h2 className="font-semibold text-lg">{product.name}</h2>
                    {product.items.map((item, i) => (
                      <Link
                        to="/pricing"
                        className="flex flex-row items-center gap-3 hover:bg-[#E8E8E8] p-2 rounded-lg parent"
                        key={i}
                      >
                        <div className="bg-[#DCE6F6] text-brandColor h-[50px] w-[50px] min-w-[50px] flex flex-row items-center justify-center rounded-lg">
                          {<item.icon className="!text-3xl" />}
                        </div>
                        <div className="space-y-1">
                          <h2 className="text-lg font-semibold">{item.name}</h2>
                          <p className="text-gray-600">{item.text}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="hidden z-50 flex-col items-center space-y-2 lg:flex lg:flex-row lg:w-max lg:space-y-0 lg:space-x-10">
            {accounts.map((link, i) => (
              <Link
                onClick={() => hideNavBar()}
                to={
                  link.name === "Create free account"
                    ? lipana_signup()
                    : lipana_login()
                }
                key={i}
                className={`font-semibold ${
                  link.type === "btn"
                    ? `bg-[#0567FB] text-base py-2 px-5 rounded-full text-white w-full lg:w-max hover:opacity-[0.8] duration-500`
                    : ` hover:text-brandColor duration-500`
                }`}
              >
                {`${link.name === "Sign In" ? link.name : link.name}`}
              </Link>
            ))}
          </div>

          <div className="space-x-10 flex flex-row items-center lg:hidden">
            <Link to={lipana_login()} className="font-semibold">
              Sign In
            </Link>
            <Link
              to={lipana_signup()}
              className="hidden font-semibold  bg-[#0567FB] py-2 px-5 rounded-full text-white md:block lg:hidden hover:opacity-[0.8] duration-500"
            >
              Create Free Account
            </Link>
          </div>

          <div className="flex flex-row items-center space-x-3 z-45 mr-4 lg:mr-0 lg:hidden">
            <AiOutlineMenu className="text-2xl" onClick={() => setNavBar()} />
          </div>
        </div>
      </div>
      <MobileNav
        navData={navData}
        accounts={accounts}
        hideNavBar={hideNavBar}
        active={active}
        products={products}
      />
    </nav>
  );
};

export default Nav;
